// Palabras clave que Paycomet usa en errores relacionados con número de tarjeta (PAN)
// Esta regex se usa en MutationObserver para clasificar errores del SDK
export const PAN_ERROR_KEYWORDS = /tarjeta|card|n[uú]mero|number|PAN|invalid|incorrecto|inv[aá]lido|no v[aá]lido/i;
